import { h, Component } from 'preact';
import { translate } from 'react-i18next';

import Button from './Button.js';


class ChangePassword extends Component {

  validateForm = (currentPass, newPass, confirmPass) => {
  	this.setState({
      errorCurrentPassword: undefined,
      errorNewPassword: undefined,
      errorConfirmPassword: undefined
    });
  	if (!currentPass) {
  		this.setState({ errorCurrentPassword: 'You must enter your current password.' });
  		return false;
  	}
  	if (!newPass) {
  		this.setState({ errorNewPassword: 'You must enter your current password.' });
  		return false;
  	}
  	if (!confirmPass) {
  		this.setState({ errorConfirmPassword: 'You must enter your current password.' });
  		return false;
  	}
  	if (newPass !== confirmPass) {
  		this.setState({ errorConfirmPassword: 'Passwords do not match. Please try again.' });
  		return false;
  	}
  	return true;
  }
  
  submitPasswordChange = (e) => {

  	this.setState({ buttonPasswordChange: 'loading' });
  	if (this.validateForm(this.state.currentPassword, this.state.newPassword, this.state.confirmPassword)) {
  		fetch('https://api.hirezstudios.com/acct/changePassword', {
  		method: 'post',
  		headers: {
  			'Content-Type': 'application/json'
  		},
  		body: `{"webToken": "${this.props.userData.webToken}", "oldPassword": "${this.state.currentPassword}", "newPassword": "${this.state.newPassword}", "confirmNewPassword": "${this.state.confirmPassword}"}`
    	}).then((response) => {
        this.setState({ buttonPasswordChange: 'initial' });
        if (response.status === 500) {
          this.setState({ errorConfirmPassword: 'Something went wrong. Please try again.' });
        } else {
					this.props.notification('success', 10000, `You've successfully changed your password.`);
          this.setState({
            currentPassword: undefined,
            newPassword: undefined,
            confirmPassword: undefined
          });
        }
      })
    }
    else {
  		this.setState({ buttonPasswordChange: 'initial' });
  	}
  }

  constructor(props) {
  	super(props);
  	this.state = {
      currentPassword: undefined,
      newPassword: undefined,
      confirmPassword: undefined,
  		errorCurrentPassword: undefined,
      errorNewPassword: undefined,
      errorConfirmPassword: undefined,
      buttonPasswordChange: 'initial'
  	};
  }

  render() {
		const { t } = this.props;
  	return (
  		<div className="c-ChangePassword">
  			<h4>{t('Change Your Password')}</h4>
  			<form className="change-password">
  				<div className="current-password">
  					<label>{t('Current Password')}</label>
  					<div className="input-wrapper">
              <input
                id="current-password"
                type="password"
                onInput={e => this.setState({ currentPassword: e.target.value })}
                value={this.state.currentPassword}
              />
  						<div className="error-current-password">{t(this.state.errorCurrentPassword)}</div>
  					</div>
  				</div>
  				<div className="new-password">
  					<label>{t('New Password')}</label>
  					<div className="input-wrapper">
              <input
                id="new-password"
                type="password"
                onInput={e => this.setState({ newPassword: e.target.value })}
                value={this.state.newPassword}
              />
  						<div className="error-new-password">{t(this.state.errorNewPassword)}</div>
  					</div>
  				</div>
  				<div className="confirm-password">
  					<label>{t('Confirm New Password')}</label>
  					<div className="input-wrapper">
              <input
                id="confirm-password"
                type="password"
                onInput={e => this.setState({ confirmPassword: e.target.value })}
                value={this.state.confirmPassword}
              />
  						<div className="error-confirm-password">{t(this.state.errorConfirmPassword)}</div>
  					</div>
  				</div>
  				<div className="buttons-wrapper">
            <Button 
              color="blue"
              copy={t('Change')}
              state={this.state.buttonPasswordChange}
              onClick={this.submitPasswordChange}
            />
  				</div>
  			</form>
  		</div>
  	);
  }
}

export default translate(['common'], { withRef: true })(ChangePassword);



// WEBPACK FOOTER //
// ./components/ChangePassword.js